import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import * as reducers from 'Store/reducers';
import { getLicenseType } from 'Settings/pricing-options';
import SiteHeaderLink from 'Components/SiteHeaderLink';

import styles from './SiteNav.scss';
import UserIcon from './user-icon.svg';
import ArrowIcon from './arrow.svg';
import { ROUTES } from 'Settings/route-strings';

const Burger = ({ clickHandler }) => (
  <svg
    className="SiteNav__button--burger"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    onClick={(e) => {
      clickHandler(e);
    }}
  >
    <g fill="none" fillRule="evenodd">
      <rect className="svg-line-1" width="24" height="4" y="2" rx="2" />
      <rect className="svg-line-2" width="24" height="4" y="11" rx="2" />
      <rect className="svg-line-3" width="24" height="4" y="20" rx="2" />
    </g>
  </svg>
);

class SiteNav extends React.PureComponent {
  constructor(props) {
    super(props);

    this.navItems = {
      signin: {
        route: ROUTES.SIGN_IN,
        type: 'button',
        buttonType: 'secondary-tab',
        additionalClasses: ' Button--signin',
      },
      signout: {
        route: ROUTES.SIGN_OUT,
        type: 'button',
        buttonType: 'secondary',
        additionalClasses: ' Button--signout',
      },
      freetrial: {
        route: ROUTES.FREE_TRIAL_ONLINE_LEARNING, // TODO: Change back to normal free trial link
        type: 'button',
        buttonType: 'tertiary',
        additionalClasses: ' Button--trial',
      },
      account: {
        route: ROUTES.SETTINGS_ACCOUNT,
        type: 'text',
      },
      schoolsettings: {
        route: '/settings/school', // NOTE: NOT IN USE
        type: 'text',
      },
      pricing: {
        route: ROUTES.PRICING,
        type: 'text',
      },
      apps: {
        route: ROUTES.EXPLORE,
        type: 'text',
      },
      classes: {
        route: ROUTES.CLASSES,
        type: 'text',
      },
      users: {
        route: ROUTES.USERS,
        type: 'text',
      },
      schools: {
        route: ROUTES.SCHOOLS,
        type: 'text',
      },
      stats: {
        route: ROUTES.ADMIN_STATS,
        type: 'text',
      },
    };

    this.state = {
      menuVisible: false,
    };

    this.handleButtonClick = this.handleButtonClick.bind(this);
    this.handleAnyClick = this.handleAnyClick.bind(this);
    this.getNavSet = this.getNavSet.bind(this);
  }

  componentDidMount() {
    window.addEventListener('click', this.handleAnyClick, false);
  }

  componentWillUnmount() {
    window.removeEventListener('click', this.handleAnyClick);
  }

  getNavSet() {
    const { activeUser, schoolLicenses } = this.props;
    const planType =
      schoolLicenses && schoolLicenses[0]
        ? getLicenseType[schoolLicenses[0].license_type]
        : 'school';

    if (activeUser) {
      const navSet = ['apps'];

      if (activeUser.isSuperAdmin) navSet.push('stats');
      if (activeUser.isSuperAdmin) navSet.push('schools');
      if (activeUser.isEducator) navSet.push('users');
      if (activeUser.isEducator && planType === 'school')
        navSet.push('classes');
      return navSet;
    }
    return ['pricing', 'freetrial', 'signin'];
  }

  static getAccountMenuProps(activeUser) {
    const menuItems = ['signout'];
    if (activeUser.isAdmin) menuItems.unshift('schoolsettings');
    if (activeUser.isEducator) menuItems.unshift('account');
    return menuItems;
  }

  handleButtonClick(e) {
    e.stopPropagation();
    this.setState((prevState) => ({ menuVisible: !prevState.menuVisible }));
  }

  handleAnyClick(e) {
    if (!this.state.menuVisible) return null;

    const isADescendant = (parent, target) => {
      const descendants = parent.querySelectorAll('*');
      let value = false;
      descendants.forEach((el) => {
        if (el === target) value = true;
      });
      return value;
    };

    const isInNav = isADescendant(this.SiteNavEl, e.target);
    const shouldClose =
      !isInNav || (isInNav && e.target.tagName.match(/^(A|SPAN)$/));
    if (shouldClose) this.setState({ menuVisible: false });
  }

  render() {
    const { activeUser, schoolLicenses, isFetchingActiveUser } = this.props;

    if (
      isFetchingActiveUser ||
      (activeUser && activeUser.isEducator && !schoolLicenses)
    ) {
      return null;
    }

    const { menuVisible } = this.state;
    const navSet = this.getNavSet();
    const navItems = (
      <div className="SiteNav__items">
        {navSet.map((id) => {
          return (
            <SiteHeaderLink {...this.navItems[id]} id={id} key={`link-${id}`} />
          );
        })}
      </div>
    );
    return (
      <div
        className="SiteNav"
        data-menu-visible={menuVisible && activeUser !== null}
        data-logged-in={activeUser ? 'true' : 'false'}
        data-touch-device={'ontouchstart' in window}
        ref={(div) => {
          this.SiteNavEl = div;
        }}
      >
        {activeUser
          ? [
              <Burger
                clickHandler={this.handleButtonClick}
                key="burger-menu"
              />,
              <div
                className="SiteNav__button--account"
                onClick={(e) => this.handleButtonClick(e)}
                key="account-menu"
                role="button"
              >
                <div className="SiteNav__button-label">
                  {activeUser.given_name}
                </div>
                <UserIcon className="SiteNav__user-icon" />
                <ArrowIcon className="SiteNav__arrow-icon" />
              </div>,
              <div className="SiteNav__item-container" key="item-container">
                {navItems}
                <div className="SiteNav__menu-items">
                  {this.constructor
                    .getAccountMenuProps(activeUser)
                    .map((id) => {
                      return (
                        <SiteHeaderLink
                          {...this.navItems[id]}
                          id={id}
                          key={`menu-link-${id}`}
                        />
                      );
                    })}
                </div>
              </div>,
            ]
          : navItems}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const activeSchool = reducers.getActiveSchool(state);
  return {
    activeUser: reducers.getActiveUser(state),
    schoolLicenses: activeSchool
      ? reducers.getLicensesForSchool(state, activeSchool.id) || []
      : [],
    isFetchingActiveUser: reducers.getIsFetchingActiveUser(state),
  };
};

export default withRouter(connect(mapStateToProps)(SiteNav));
